var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TYPOGRAPHY_VARIANTS } from '../typography/typography';
export var getToolTipStyles = function (theme) { return (__assign(__assign({}, TYPOGRAPHY_VARIANTS['text-xs-semibold']), { backgroundColor: theme.backrs.colors['Colors/Background/bg-primary-solid'], padding: theme.backrs.spacing['spacing-md'], borderRadius: theme.backrs.radius['radius-md'], opacity: 1 })); };
export var getToolTipArrowStyles = function (theme) { return ({
    color: theme.backrs.colors['Colors/Background/bg-primary-solid'],
}); };
